import { Pipe } from "@angular/core";
import { SimpleTableColumn } from "./simple-table-column";

export class PipedTableColumn extends SimpleTableColumn {
    pipe: Pipe | string;
    pipeArgument: any;
    pipeArgumentResolver: (pipeArgument: any, element: any) => any;
    isArgumentPath: boolean;
    pipeArgumentObjectName: string;
    localizationEnabled: boolean;

    constructor(name: string, label: string, path: string, pipe: Pipe | string) {
        super(name, label, path);
        this.pipe = pipe;
    }

    withArgument(pipeArgument: any, isArgumentPath: boolean = false, pipeArgumentObjectName?: string): PipedTableColumn {
        this.pipeArgument = pipeArgument;
        this.isArgumentPath = isArgumentPath;
        this.pipeArgumentObjectName = pipeArgumentObjectName;
        return this;
    }

    withArgumentResolver(pipeArgumentResolver: (pipeArgument: any, element: any) => any): PipedTableColumn {
        this.pipeArgumentResolver = pipeArgumentResolver;
        return this;
    }

    withLocalization(): PipedTableColumn {
        this.localizationEnabled = true;
        return this;
    }
}
